/* Permissions defined for the fleet of vehicles are used for CREATION, EDITION and DELETION of templates */
/* Permission defined for Special Offers moderation is used for car template MODERATION */
export const PERM_CAR_TEMPLATE_EDIT = 'PERM_FLEET_EDIT';
export const PERM_CAR_TEMPLATE_CREATE = 'PERM_FLEET_CREATE';
export const PERM_CAR_TEMPLATE_DELETE = 'PERM_FLEET_DELETE';
export const PERM_CAR_TEMPLATE_MODERATE = 'PERM_SPECIAL_OFFER_MODERATE';


// WEBPACK FOOTER //
// ./public/upgrade/feature/carTemplate/permissions/car-template-permissions.ts